<template>
    <div>
        <div class="row column page-content">
            <comment v-for="comment in comments" :key="comment.id" :comment="comment" class="comments-list-item"></comment>
        </div>

        <spinner v-if="loading === true" class="spinner"></spinner>

        <p v-if="comments !== null && comments.length === 0" class="text-center watermark">Tev nav neviena komentāra :(</p>

        <div class="row column pagination-container text-center">
            <pagination :current.sync="page" :total="totalPages"></pagination>
        </div>
    </div>
</template>

<script>

    import Comment from '../../components/inbox/Comment'
    import Pagination from '../../components/common/Pagination'
    import avatarIcon from '../../../icons/icon-avatar.svg-sprite'
    import user from '../../api/user'
    import { mapGetters } from 'vuex'

    export default {
        data() {
            return {
                avatarIcon,
                comments: null,
                page: 1,
                totalPages: 0,
                totalComments: 0,
                loading: false
            }
        },

        computed: {
            ...mapGetters(['user'])
        },

        created() {
            if (this.user) {
                this.getComments()
            }
        },

        methods: {
            /**
             * Get user comments
             */
            getComments() {
                this.loading = true;
                user.comments({ page: this.page })
                    .then(response => {
                        this.comments = response.data.data;
                        this.page = response.data.meta.current_page;
                        this.totalPages = response.data.meta.last_page;
                        this.totalComments = response.data.meta.total;
                        this.loading = false;
                });
            }
        },

        components: {
            Comment, Pagination
        },

        watch: {
            user: function (val, oldVal) {
                console.log('user changed');
                this.getComments();
            },

            page: function (val, oldVal) {
                this.getComments()
            }
        }
    }
</script>

<style lang="scss">
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    .comments-list-item {
        padding: (40px / 16px + em) 0;

        &:not(:last-child) {
            border-bottom: 1px solid $body-background;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/inbox/InboxComments.vue